__turbopack_context__.v({
  "postArticle": "view-module__N9FfAW__postArticle" + " " + __turbopack_context__.i(443839)["articleStandard"],
  "postContent": "view-module__N9FfAW__postContent",
  "postFooter": "view-module__N9FfAW__postFooter",
  "postFullHeader": "view-module__N9FfAW__postFullHeader",
});
